import brandedStoresHubImage from '../../assets/images/AllBlogImages/BlogHubImages/brandedStoresHubImage.webp'
import Butter99FatHubImage from '../../assets/images/AllBlogImages/BlogHubImages/Butter99FatHubImage.webp'
import transportationOfOutProductsHubImage from '../../assets/images/AllBlogImages/BlogHubImages/transportationOfOutProductsHubImage.webp'
import butterAnIndicatorOfSkillHubImage from '../../assets/images/AllBlogImages/BlogHubImages/butterAnIndicatorOfSkillHubImage.webp'
import whyYogurtIsHealthyHubImage from '../../assets/images/AllBlogImages/BlogHubImages/whyYogurtIsHealthyHubImage.webp'
import kefirAtNightHubImage from '../../assets/images/AllBlogImages/BlogHubImages/kefirAtNightHubImage.webp'

export const BlogHubArr = {
    metaTitle: "Блог Доманівського маслосирзаводу | Pastoral™",
    metaDescription: "Читайте корисні статті про молочну продукцію: виготовлення масла, користь йогурту, транспортування, магазини Pastoral та багато іншого.",
    articles: [
        {
            link: "branded-stores",
            image: brandedStoresHubImage,
            title: "Фірмові магазини “Pastoral” та “Молокомаркет”!",
            description: "Доманівський маслосирзавод запрошує Вас до фірмових магазинів “Pastoral” - “Молокомаркет”! Тут, в одному місці, зібрані всі ваші улюблені молочні продукти — завжди свіжі, натуральні та за цінами виробника. Ми створили ці магазини, щоб зробити якісну молочну продукцію ближчою до вас. Щоб кожен візит був не просто покупкою, а приємним смачним ритуалом.",
        },
        {
            link: "butter-99-fat",
            image: Butter99FatHubImage,
            title: "Масло 99% жирності – це що?",
            description: "Виготовлення масла ГХІ - вкрай складний процес. Спочатку потрібно виготовити якісне солодковершкове масло, а потім із нього топлене. Готове масло при температурі приблизно 110-120°C поступово розтоплюється, щоб зберегти всі корисні речовини та уникнути підгоряння. ",
        },
        {
            link: "transportation-of-our-products",
            image: transportationOfOutProductsHubImage,
            title: "Перевезення нашої продукції",
            description: "Молочна продукція містить велику кількість вітамінів та мінералів, які необхідні для нормального розвитку організму, що робить її одним із найбільш популярних харчових продуктів, які щодня вживаються багатьма людьми. Досить важко знайти сім'ю, яка не любила б якийсь молочний продукт.",
        },
        {
            link: "butter-an-indicator-of-skill",
            image: butterAnIndicatorOfSkillHubImage,
            title: "Вершкове масло – показник майстерності",
            description: "Для молочних брендів саме масло є показником майстерності – за його якістю можна судити про всю продукцію марки. Масло – це один із найчутливих до якості молочних продуктів. Його склад, смак і текстура напряму залежать від технології виробництва, добору сировини та професіоналізму виробника.",
        },
        {
            link: "why-yogurt-is-healthy",
            image: whyYogurtIsHealthyHubImage,
            title: "Чому корисний йогурт",
            description: "Йогурт без штучних підсолоджувачів, відомий своїми пробіотиками, дійсно є корисним для мікрофлори кишківника, сприяючи здоровому травленню. Однак його переваги для здоров'я цим не обмежуються. Цей натуральний продукт також багатий на білки, кальцій і вітаміни групи B",
        },
        {
            link: "kefir-at-night",
            image: kefirAtNightHubImage,
            title: "Кефір на ніч",
            description: "Лікарі рекомендують щодня вживати напої, багаті на триптофан, щоб підтримувати гарний настрій, бути здоровими та добре спати. Нутриціологи виділяють напої, які допомагають боротися зі стресом, слабкістю та безсонням, що часто виникають через тривожні стани.",
        },
    ]
}

